var _circle, _path, _g, _g2, _path2, _g3, _path3, _g4, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllSsoApple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 376 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 187.978,
    cy: 164.656,
    r: 100,
    fill: "#9AA0DA",
    fillOpacity: 0.14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.0851 245.994L30.7037 118.762C28.8285 112.379 33.0034 105.806 39.5774 104.79L159.884 86.1952C164.2 85.5282 168.371 88.0553 169.779 92.1892L209.399 208.573C211.487 214.707 207.848 221.307 201.548 222.816L78.8163 252.209C74.1548 253.326 69.4362 250.593 68.0851 245.994Z",
    fill: "url(#paint0_linear_14403_25275)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter0_i_14403_25275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.6835 242.968L32.801 114.805C31.4109 110.102 34.4805 105.251 39.3258 104.493L160.804 85.5024C164.685 84.8957 168.443 87.1576 169.723 90.871L210.418 208.87C211.984 213.412 209.28 218.313 204.603 219.41L80.3129 248.564C76.127 249.546 71.9022 247.091 70.6835 242.968Z",
    fill: "url(#paint1_linear_14403_25275)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.133 124.57C103.078 131.378 96.0348 138.199 89.0044 145.031C87.8892 145.932 87.609 147.486 88.012 148.796C88.4563 150.24 89.6955 151.478 91.2057 151.846C99.2343 153.707 122.042 158.932 122.042 158.932C122.042 158.932 127.612 154.753 128.36 154.192C130.452 152.624 132.545 151.057 134.638 149.491C127.836 143.461 121.042 137.422 114.255 131.376C113.34 130.561 112.424 129.746 111.508 128.931C111.251 128.703 110.994 128.474 110.737 128.246C110.666 128.183 110.585 127.983 110.461 128.004C110.107 127.651 109.797 127.231 109.647 126.754C109.414 126.01 109.562 125.135 110.133 124.57Z",
    fill: "#2DB2B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.636 149.488C130.435 152.632 122.04 158.929 122.04 158.929C122.04 158.929 143.072 163.694 152.414 165.783C152.933 165.92 153.432 166.14 153.866 166.452C147.447 160.807 141.037 155.152 134.636 149.488Z",
    fill: "#7280FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.455 128.002C118.501 135.179 126.56 142.34 134.633 149.487C138.01 146.96 141.39 144.436 144.772 141.914L144.771 141.912C145.903 141.042 146.169 139.488 145.755 138.197C145.344 136.914 144.3 135.806 143.002 135.347L142.997 135.334C132.735 131.645 122.481 127.933 112.236 124.198C111.872 124.072 111.476 124.029 111.094 124.095C109.836 124.312 109.293 125.639 109.642 126.752C109.792 127.231 110.056 127.681 110.455 128.002Z",
    fill: "#00D5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.712 190.07C125.557 182.903 117.416 175.721 109.288 168.524C105.787 171.164 102.287 173.805 98.7894 176.449L98.7899 176.451C97.6134 177.367 97.3029 178.987 97.7217 180.348C98.1303 181.676 99.1998 182.827 100.549 183.284L100.552 183.298C111.008 186.903 121.472 190.484 131.946 194.04L131.947 194.038C132.314 194.156 132.713 194.188 133.092 194.108C134.362 193.838 134.891 192.457 134.535 191.326C134.384 190.844 134.118 190.389 133.712 190.07Z",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.057 193.585C140.909 186.531 147.773 179.487 154.649 172.454C155.716 171.543 155.957 170.015 155.547 168.737C155.099 167.337 153.89 166.133 152.416 165.784L152.415 165.783C142.285 163.517 132.16 161.232 122.04 158.927C117.786 162.122 113.534 165.321 109.286 168.523C117.414 175.721 125.555 182.903 133.711 190.07C134.069 190.424 134.381 190.846 134.532 191.326C134.773 192.092 134.622 192.989 134.057 193.585Z",
    fill: "#FF3F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.288 168.524C113.536 165.322 117.787 162.124 122.04 158.929C111.756 156.588 101.477 154.226 91.2026 151.845C90.6741 151.702 90.167 151.479 89.7263 151.158C96.238 156.957 102.759 162.745 109.288 168.524Z",
    fill: "#7280FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14403_25275",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 85,
    width: 179,
    height: 164
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6835 242.968L32.801 114.805C31.4109 110.102 34.4805 105.251 39.3258 104.493L160.804 85.5024C164.685 84.8957 168.443 87.1576 169.723 90.871L210.418 208.87C211.984 213.412 209.28 218.313 204.603 219.41L80.3129 248.564C76.127 249.546 71.9022 247.091 70.6835 242.968Z",
    fill: "url(#paint2_linear_14403_25275)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14403_25275)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M288.93 228.316L319.298 99.2296C320.821 92.7542 316.293 86.4191 309.673 85.764L188.53 73.7761C184.184 73.346 180.157 76.0976 178.978 80.3022L145.781 198.679C144.032 204.917 148.026 211.308 154.399 212.471L278.555 235.109C283.27 235.968 287.832 232.982 288.93 228.316Z",
    fill: "url(#paint3_linear_14403_25275)"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M320.486 207.413L347.895 60.5645C349.116 54.0254 344.298 47.9077 337.655 47.5612L200.628 40.4146C196.267 40.1871 192.372 43.123 191.389 47.3779L160.235 182.329C158.778 188.641 163.065 194.84 169.486 195.705L310.438 214.681C315.189 215.321 319.607 212.125 320.486 207.413Z",
    fill: "url(#paint4_linear_14403_25275)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_14403_25275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.297 204.269L345.073 56.7879C345.981 51.9685 342.437 47.4525 337.54 47.1886L199.618 39.7564C195.696 39.5451 192.186 42.1751 191.287 45.999L159.217 182.44C158.118 187.117 161.303 191.719 166.067 192.338L308.282 210.81C312.546 211.364 316.501 208.494 317.297 204.269Z",
    fill: "url(#paint5_linear_14403_25275)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M268.981 87.0424C272.446 84.2315 274.963 80.1452 275.606 75.7035C274.005 75.5839 272.385 75.8245 270.844 76.2529C267.997 77.0434 265.294 78.4935 263.065 80.4313C259.987 83.238 256.923 87.1464 256.901 91.5131C258.459 91.8386 260.085 91.692 261.614 91.2915C264.371 90.5684 266.951 89.0334 268.981 87.0424ZM271.559 93.6835C268.594 93.4391 265.643 93.9819 262.77 94.6604C261.561 94.9461 260.359 95.2616 259.145 95.5278C258.267 95.72 257.333 95.9069 256.429 95.831C254.622 95.6797 252.884 94.4749 251.352 93.6488C249.325 92.5551 247.173 91.5957 244.838 91.4823C238.172 91.0633 231.647 94.5115 227.386 99.4941C224.26 103.18 222.329 107.739 221.392 112.453C220.343 117.637 220.375 123.045 221.269 128.249C221.806 131.382 222.659 134.489 223.965 137.392C224.232 137.978 224.542 138.655 224.821 139.235C226.659 143.068 229.249 147.644 233.935 148.147C236.586 148.432 238.946 147.419 241.466 146.788C243.311 146.326 245.195 146.18 247.087 146.381C248.571 146.538 250.009 146.929 251.356 147.572C252.762 148.245 254.029 149.172 255.436 149.843C256.534 150.367 257.702 150.702 258.912 150.832C263.837 151.362 267.938 147.535 271.102 144.269C271.603 143.753 272.156 143.162 272.645 142.635C274.758 140.511 276.63 138.153 278.26 135.641C278.76 134.87 279.234 134.082 279.687 133.283C279.716 133.232 280.066 132.473 280.258 132.298C279.976 132.271 279.581 131.917 279.348 131.758C278.483 131.17 277.681 130.487 276.953 129.737C274.716 127.435 273.216 124.499 272.767 121.313C272.521 119.57 272.58 117.794 272.871 116.06C274.125 109.858 278.603 104.983 284.238 102.328C282.031 97.2711 276.994 94.1314 271.559 93.6835Z",
    fill: "url(#paint6_linear_14403_25275)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_14403_25275",
    x: 32.4651,
    y: 85.4045,
    width: 178.399,
    height: 163.376,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14403_25275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_14403_25275",
    x: 158.999,
    y: 39.7446,
    width: 186.216,
    height: 171.134,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14403_25275"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14403_25275",
    x1: 43.1318,
    y1: 111.066,
    x2: 205.349,
    y2: 217.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#D7D7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14403_25275",
    x1: 57.9395,
    y1: 115.706,
    x2: 153.57,
    y2: 179.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14403_25275",
    x1: 98.1675,
    y1: 147.087,
    x2: 176.459,
    y2: 181.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14403_25275",
    x1: 220.575,
    y1: 224.126,
    x2: 94.9727,
    y2: 109.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E7F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14403_25275",
    x1: 333.067,
    y1: 54.8141,
    x2: 171.276,
    y2: 189.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504877,
    stopColor: "#D4D4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_14403_25275",
    x1: 193.292,
    y1: 35.5517,
    x2: 268.467,
    y2: 197.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_14403_25275",
    x1: 263.079,
    y1: 128.853,
    x2: 227.849,
    y2: 63.8685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllSsoApple);
export default __webpack_public_path__ + "static/media/ill-sso-apple.12e6f5b4be7eedc13d5920c344a4b198.svg";
export { ForwardRef as ReactComponent };